import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestUpdate() {
  const latest = [...comics]
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 8);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-2">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500">每日同步更新，追更不等待</p>
          </div>
          <Link
            to="/category/action"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1"
          >
            更多更新 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4" data-product-shop>
          {latest.map((comic) => {
            const cat = comic.category;
            const catMap: Record<string, string> = {
              romance: '恋爱甜宠',
              fantasy: '奇幻冒险',
              action: '热血动作',
              drama: '都市情感',
              comedy: '搞笑日常',
              thriller: '悬疑惊悚',
              historical: '古风历史',
              bl: 'BL专区',
            };
            return (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="group flex gap-4 p-4 bg-background-100 rounded-lg hover:bg-background-200/70 transition-colors cursor-pointer"
              >
                <div className="w-[72px] h-[100px] flex-shrink-0 rounded-md overflow-hidden bg-background-200">
                  <img
                    src={comic.cover}
                    alt={`${comic.title} - 韩漫之家免费阅读`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0 flex flex-col justify-between">
                  <div>
                    <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                      {comic.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-1 line-clamp-2">
                      {comic.description}
                    </p>
                  </div>
                  <div className="flex items-center gap-3 mt-2">
                    <span className="text-xs px-2 py-0.5 bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
                      {catMap[cat] || cat}
                    </span>
                    <span className="text-xs text-primary-500 font-medium whitespace-nowrap">
                      {comic.updateTo}
                    </span>
                    <span className="text-xs text-foreground-400 ml-auto whitespace-nowrap">
                      {comic.updatedAt}
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}